import React from "react"
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";


export default function TourLib() {

    const {t} = useTranslation("tours")

    const styles = {
        defaultTextContent: {
            fontSize: 14
        }
    }

    const homeTourSteps: any = [
        {
            step: 1,
            title: t("packaging_tour"),
            subtitle: t("download_your_qrcodes"),
            content: <Typography sx={styles.defaultTextContent}>{t("download_your_qrcodes_text")}</Typography>,
            position: "bottom"
        },
        {
            step: 2,
            title: t("packaging_tour"),
            subtitle: t("check_your_health"),
            content: <Typography sx={styles.defaultTextContent}>{t("check_your_health_text")}</Typography>,
            position: "bottom"
        }
    ]

    return {homeTourSteps}
}